
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Home = lazy(() => import("@/pages/home/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
